import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/images_empty"
  }, React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.05832 0.29781C7.3291 0.195326 6.65488 0.70339 6.55239 1.4326L6.3042 3.1986L7.68015 2.98862L7.87275 1.61817L13.8144 2.45321L12.9793 8.39482L11.1826 8.1423L11.5597 10.8882L12.6082 11.0355C13.3374 11.138 14.0116 10.6299 14.1141 9.90074L15.1347 2.63877C15.2372 1.90956 14.7291 1.23533 13.9999 1.13285L8.05832 0.29781Z",
    fill: "currentColor"
  }), React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.86513 6.63896C0.762645 5.90975 1.27071 5.23552 1.99992 5.13304L7.94153 4.298C8.67074 4.19552 9.34497 4.70358 9.44745 5.43279L10.4681 12.6948C10.5705 13.424 10.0625 14.0982 9.33326 14.2007L3.39165 15.0357C2.66244 15.1382 1.98822 14.6301 1.88573 13.9009L0.86513 6.63896ZM3.69146 7.58806C3.74271 7.95266 3.48867 8.28978 3.12407 8.34102C2.75946 8.39226 2.42235 8.13823 2.37111 7.77362C2.31987 7.40902 2.5739 7.0719 2.9385 7.02066C3.30311 6.96942 3.64022 7.22345 3.69146 7.58806ZM9.05495 12.2198L8.49826 8.25879L6.28846 11.3969L5.00741 10.3652L3.11334 13.0549L7.56951 12.4287L7.56945 12.4286L9.05495 12.2198Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { ImagesEmpty16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var ImagesEmpty16 = createIcon(IconComponent);